import classNames from 'classnames';
import { FC, memo } from 'react';

interface iEnumProps {
  value?: string;
  onChange: (val: string) => void;
  isSeparated?: boolean;
  options: { label: string; value: string; icon?: any }[];
  error?: string;
}

const Enum: FC<iEnumProps> = memo(({ options, value, onChange, isSeparated, error }) => {
  const _handleChange = (val: string) => () => onChange(val);
  return (
    <div className={classNames('enum-wrapper', isSeparated && 'separated', error && 'error')}>
      {options.map((option) => (
        <div
          onClick={_handleChange(option.value)}
          key={option.value}
          className={classNames('option-wrapper', value === option.value && 'active')}
        >
          {option.icon}
          <label>{option.label}</label>
        </div>
      ))}
    </div>
  );
});

export default Enum;
